export const helpers = {toPersianNumber, toEnglishNumber, toPersianNo};

function toPersianNumber(value) {
    //return parseFloat(value).toLocaleString(navigator.language, { minimumFractionDigits: 0 }).replace(/٬/g,'');
    //۱۲۳۴۵۶۷۸۹۰
    return (value + '').replace(/1/g, '۱').replace(/2/g, '۲').replace(/3/g, '۳').replace(/4/g, '۴').replace(/5/g, '۵').replace(/6/g, '۶').replace(/7/g, '۷').replace(/8/g, '۸').replace(/1/g, '۱').replace(/1/g, '۱').replace(/9/g, '۹').replace(/0/g, '۰');
}

function toEnglishNumber(value) {
    //return parseFloat(value).toLocaleString(navigator.language, { minimumFractionDigits: 0 }).replace(/٬/g,'');
    //۱۲۳۴۵۶۷۸۹۰
    return (value + '').replace(/,/g, '').replace(/۱/g, '1').replace(/۲/g, '2').replace(/۳/g, '3').replace(/۴/g, '4').replace(/۵/g, '5').replace(/۶/g, '6').replace(/۷/g, '7').replace(/۸/g, '8').replace(/۹/g, '9').replace(/۰/g, '0');
}

const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];

function toPersianNo(str) {
    if (typeof str === 'string') {
        for (let i = 0; i < 10; i++) {
            str = str.replace(persianNumbers[i], i);
        }
    }
    return str;
}